<template>
  <div>
    <div class="contenedor_estacion" style="width:200px">
      <span>Estacion: </span>
      <span id="n_estacion" class="n_estacion"></span>
    </div>
 
    <b-row>
      <b-col xl="6" lg="12">
        <b-card no-body v-if="mostrarSemAct">
          <b-card-body class="px-1 pb-0 pt-1">
            <b-row>
              <b-col xl="1" lg="1" md="1" class="mb-1" align="center">
                <b-button-group>
                  <b-button
                      variant="gradient-primary"
                      size="sm"
                      @click="mostrarSemAct = false"
                      id="btn_back"
                      v-b-tooltip.hover="'Regresar'"
                  >
                    <font-awesome-icon icon="fa-solid fa-arrow-left-long"/>
                  </b-button>
                </b-button-group>
              </b-col>
              <b-col xl="11" lg="11" md="1" class="mb-1" align="center">
                <span class="font-weight-bolder font-small-4" style="vertical-align: -webkit-baseline-middle!important;">{{`Detalle de registro - Total: ${this.items_sem_act.length}` }}</span>
              </b-col>
            </b-row>
          </b-card-body>

          <!-- <b-table
              v-if="$can('read', 'Pr Fert Programacion')"
              ref="tableDetalleSemanaActual"
              responsive
              hover
              outlined
              small
              sticky-header="58vh"
              class="position-relative tablaferti"
              :items="items_sem_act"
              :fields="fields_detalle_SemAct"
              :busy="loading"
              show-empty
              empty-text="No se encontraron datos en esta tabla."
          >
            <template #table-busy>
              <div class="text-center text-dark my-1">
                <b-spinner class="align-middle"></b-spinner> &emsp;
                <strong>Obteniendo datos...</strong>
              </div>
            </template>

            <template #cell(acciones)="data">
              <div class="text-nowrap">
                <feather-icon
                    v-if="$can('update', 'Pr Fert Programacion')"
                    :id="`btn_${data.item.id}_editar`"
                    icon="EditIcon"
                    size="16"
                    @click="validarEditar(data.item, true)"
                    v-b-tooltip.hover="'Editar registro'"
                />
              </div>
            </template>

            <template #cell(estado)="data">
              <b-badge :variant="status[1][parseInt(data.value)]">
                {{ status[0][parseInt(data.value)] }}
              </b-badge>
            </template>

            <template #cell(created)="data">
          <span>
            {{
              new Date(data.value).toLocaleString('pe-PE', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                localeMatcher: 'best fit',
                hour: '2-digit',
                minute: '2-digit',
                timeZone: 'America/Lima'
              })
            }}
          </span>
            </template>
          </b-table> -->
        </b-card>

        <b-card no-body v-else>
          <b-card-body class="px-1 pb-0 pt-1">
            <b-row>
              <b-col xl="1" lg="1" md="1" class="mb-1 align-self-center">
                <b-button-group>
                  <b-button
                      variant="gradient-primary"
                      size="sm"
                      id="act_semAct"
                      :disabled="loading"
                      v-b-tooltip.hover="'Actualizar Tabla'"
                      @click="obtenerRegsEntregaRecepcionIndumentaria"
                  >
                    <font-awesome-icon icon="fa-solid fa-arrows-rotate" :spin="loading"/>
                  </b-button>
                  <b-button

                      variant="gradient-primary"
                      size="sm"
                      @click="modal_registro(true)"
                      id="cre_semAct"
                      :disabled="loadingSAC"
                      v-b-tooltip.hover="'Crear Registro'"
                  >
                    <font-awesome-icon v-if="loadingSAC" icon="fa-solid fa-arrows-rotate" spin/>
                    <font-awesome-icon v-else icon="fa-solid fa-plus"/>
                  </b-button>
                  <!-- <b-button
                      variant="gradient-primary"
                      size="sm"
                      v-if="$can('create', 'Pr Fert Programacion')"
                      @click="mostrarModalImportar(true)"
                      id="imp_semAct"
                      :disabled="loadingSAM"
                      v-b-tooltip.hover="'Importar Registros'"
                  >
                    <font-awesome-icon v-if="loadingSAM" icon="fa-solid fa-arrows-rotate" spin/>
                    <font-awesome-icon v-else icon="fa-solid fa-file-excel"/>
                  </b-button>
                  <b-button
                      variant="gradient-primary"
                      size="sm"
                      v-if="$can('create', 'Pr Fert Programacion')"
                      @click="descargarRegistros(true)"
                      id="imp_semAct"
                      :disabled="loadingSAD"
                      v-b-tooltip.hover="'Descargar Registros'"
                  >
                    <font-awesome-icon v-if="loadingSAM" icon="fa-solid fa-arrows-rotate" spin/>
                    <font-awesome-icon v-else icon="fa-solid fa-download"/>
                  </b-button> -->
                </b-button-group>
              </b-col>
              <b-col xl="11" lg="11" md="1" class="mb-1" align="center">
                <span class="font-weight-bolder font-medium-3" style="vertical-align: -webkit-baseline-middle!important;">Entrega</span><br>
                <!-- <span class="font-weight-bolder font-medium-3" style="vertical-align: -webkit-baseline-middle!important;">{{`Semana actual N° ${this.semana}`}}</span><br> -->
                <!-- <span class="font-weight-bolder font-small-4" style="vertical-align: -webkit-baseline-middle!important;">{{`Del ${this.inicioSemana} al ${this.finSemana}` }}</span> -->
              </b-col>
            </b-row>
          </b-card-body>
          
          <!-- TABLA DE ENTREGA -->
          <b-table
              v-if="$can('read', 'Pr Fert Programacion')"
              ref="tableSemanaActual"
              responsive
              hover
              outlined
              small
              sticky-header="58vh"
              class="position-relative tablaferti"
              :items="items"
              :fields="fields"
              filter="E"
              :filter-included-fields="filterOn"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              @filtered="cPaginacion"
              :busy="loading"
              show-empty
              empty-text="No se encontraron datos en esta tabla."
              emptyFilteredText="No se encontraron datos con los parámetros ingresados."
          >
            <template #table-busy>
              <div class="text-center text-dark my-1">
                <b-spinner class="align-middle"></b-spinner> &emsp;
                <strong>Obteniendo datos...</strong>
              </div>
            </template>

            <template #cell(acciones)="data">
              <div class="text-nowrap">

                <feather-icon
                    v-if="$can('read', 'Pr Fert Programacion')"
                    :id="`btn_${data.item.id}_detalle`"
                    icon="EyeIcon"
                    size="16"
                    class="mr-1 text-primary"
                    @click="verDetalle(data.item)"
                    v-b-tooltip.hover="'Ver detalle'"
                />

                <feather-icon
                    v-if="$can('authorize', 'Pr Fert Programacion')"
                    :id="`btn_${data.item.id}_autorizar`"
                    icon="UserCheckIcon"
                    size="16"
                    @click="autorizar(data.item)"
                    v-b-tooltip.hover="'Cambiar Estado'"
                />

              </div>
            </template>

            <template #cell(estado)="data">
              <b-badge :variant="status_uno[1][parseInt(data.value)]">
                {{ status_uno[0][parseInt(data.value)] }}
              </b-badge>
            </template>

            <template #cell(accion)="data">
              <b-badge :variant="status_dos[1][data.value]">
                {{ status_dos[0][data.value] }}
              </b-badge>
            </template>

            <template #cell(created)="data">
            <span>
              {{
                new Date(data.value).toLocaleString('pe-PE', {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                  localeMatcher: 'best fit',
                  hour: '2-digit',
                  minute: '2-digit',
                  timeZone: 'America/Lima'
                })
              }}
            </span>
            </template>
          </b-table>
        </b-card>
      </b-col>
      <b-col xl="6" lg="12">
        <b-card no-body v-if="mostrarSemSgte">
          <b-card-body class="px-1 pb-0 pt-1">
            <b-row>
              <b-col xl="1" lg="1" md="1" class="mb-1" align="center">
                <b-button-group>
                  <b-button
                      variant="gradient-primary"
                      size="sm"
                      @click="mostrarSemSgte = false"
                      id="btn_backSgte"
                      v-b-tooltip.hover="'Regresar'"
                  >
                    <font-awesome-icon icon="fa-solid fa-arrow-left-long"/>
                  </b-button>
                </b-button-group>
              </b-col>
              <b-col xl="11" lg="11" md="1" class="mb-1" align="center">
                <span class="font-weight-bolder font-small-4" style="vertical-align: -webkit-baseline-middle!important;">{{`Detalle de registro - Total: ${this.items_sem_sgte.length}` }}</span>
              </b-col>

            </b-row>
          </b-card-body>

          <!-- <b-table
              v-if="$can('read', 'Pr Fert Programacion')"
              ref="tableDetalleSemanaSgte"
              responsive
              hover
              outlined
              small
              sticky-header="58vh"
              class="position-relative tablaferti"
              :items="items_sem_sgte"
              :fields="fields_detalle_SemAct"
              :busy="loading"
              show-empty
              empty-text="No se encontraron datos en esta tabla."
          >
            <template #table-busy>
              <div class="text-center text-dark my-1">
                <b-spinner class="align-middle"></b-spinner> &emsp;
                <strong>Obteniendo datos...</strong>
              </div>
            </template>

            <template #cell(acciones)="data">
              <div class="text-nowrap">
                <feather-icon
                    v-if="$can('update', 'Pr Fert Programacion')"
                    :id="`btn_${data.item.id}_editar`"
                    icon="EditIcon"
                    size="16"
                    @click="validarEditar(data.item, false)"
                    v-b-tooltip.hover="'Editar registro'"
                />
              </div>
            </template>

            <template #cell(estado)="data">
              <b-badge :variant="status[1][parseInt(data.value)]">
                {{ status[0][parseInt(data.value)] }}
              </b-badge>
            </template>

            <template #cell(created)="data">
          <span>
            {{
              new Date(data.value).toLocaleString('pe-PE', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                localeMatcher: 'best fit',
                hour: '2-digit',
                minute: '2-digit',
                timeZone: 'America/Lima'
              })
            }}
          </span>
            </template>
          </b-table> -->
        </b-card>

        <b-card no-body v-else>
          <b-card-body class="px-1 pb-0 pt-1">
            <b-row>
              <b-col xl="1" lg="1" md="1" class="mb-1 align-self-center">
                <b-button-group>
                  <b-button
                      variant="gradient-primary"
                      size="sm"
                      id="act_semSgte"
                      :disabled="loading"
                      v-b-tooltip.hover="'Actualizar Tabla'"
                      @click="obtenerRegsEntregaRecepcionIndumentaria"
                  >
                    <font-awesome-icon icon="fa-solid fa-arrows-rotate" :spin="loading"/>
                  </b-button>
                  <b-button
                      v-if="$can('create', 'Pr Fert Programacion')"
                      variant="gradient-primary"
                      size="sm"
                      @click="modal_registro(false)"
                      id="cre_semSgte"
                      :disabled="loadingSSC"
                      v-b-tooltip.hover="'Crear Registro'"
                  >
                    <font-awesome-icon v-if="loadingSSC" icon="fa-solid fa-arrows-rotate" spin/>
                    <font-awesome-icon v-else icon="fa-solid fa-plus"/>
                  </b-button>
                  <!-- <b-button
                      variant="gradient-primary"
                      size="sm"
                      v-if="$can('create', 'Pr Fert Programacion')"
                      @click="mostrarModalImportar(false)"
                      id="imp_semSgte"
                      :disabled="loadingSSM"
                      v-b-tooltip.hover="'Importar Registros'"
                  >
                    <font-awesome-icon v-if="loadingSSM" icon="fa-solid fa-arrows-rotate" spin/>
                    <font-awesome-icon v-else icon="fa-solid fa-file-excel"/>
                  </b-button>
                  <b-button
                      variant="gradient-primary"
                      size="sm"
                      v-if="$can('create', 'Pr Fert Programacion')"
                      @click="descargarRegistros(false)"
                      id="imp_semAct"
                      :disabled="loadingSSD"
                      v-b-tooltip.hover="'Descargar Registros'"
                  >
                    <font-awesome-icon v-if="loadingSAM" icon="fa-solid fa-arrows-rotate" spin/>
                    <font-awesome-icon v-else icon="fa-solid fa-download"/>
                  </b-button> -->
                </b-button-group>
              </b-col>
              <b-col xl="11" lg="11" md="11" class="mb-1" align="center">
                <span class="font-weight-bolder font-medium-3" style="vertical-align: -webkit-baseline-middle!important; margin:30px">Recepción</span><br>
                <!-- <span class="font-weight-bolder font-small-4" style="vertical-align: -webkit-baseline-middle!important;">{{`Del ${this.inicioSemana_sig} al ${this.finSemana_sig}` }}</span> -->
              </b-col>
            </b-row>
          </b-card-body>

          <!-- TABLA DE RECEPCION -->
          <b-table
              v-if="$can('read', 'Pr Fert Programacion')"
              ref="tableSemanaActual"
              responsive
              hover
              outlined
              small
              sticky-header="58vh"
              class="position-relative tablaferti"
              :items="items"
              :fields="fields"
              filter="R"
              :filter-included-fields="filterOn"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              :busy="loading"
              show-empty
              empty-text="No se encontraron datos en esta tabla."
              emptyFilteredText="No se encontraron datos con los parámetros ingresados."
          >
            <template #table-busy>
              <div class="text-center text-dark my-1">
                <b-spinner class="align-middle"></b-spinner> &emsp;
                <strong>Obteniendo datos...</strong>
              </div>
            </template>

            <template #cell(acciones)="data">
              <div class="text-nowrap">
                <feather-icon
                    v-if="$can('read', 'Pr Fert Programacion')"
                    :id="`btn_${data.item.id}_detalle`"
                    icon="EyeIcon"
                    size="16"
                    class="mr-1 text-primary"
                    @click="verDetalleSemSgte(data.item)"
                    v-b-tooltip.hover="'Ver detalle'"
                />

                <feather-icon
                    v-if="$can('authorize', 'Pr Fert Programacion')"
                    :id="`btn_${data.item.id}_autorizar`"
                    icon="UserCheckIcon"
                    size="16"
                    @click="autorizar(data.item)"
                    v-b-tooltip.hover="'Cambiar Estado'"
                />

              </div>
            </template>
            
            <template #cell(estado)="data">
              <b-badge :variant="status_uno[1][parseInt(data.value)]">
                {{ status_uno[0][parseInt(data.value)] }}
              </b-badge>
            </template>

            <template #cell(accion)="data">
              <b-badge :variant="status_dos[1][data.value]">
                {{ status_dos[0][data.value] }}
              </b-badge>
            </template>

            <template #cell(created)="data">
              <span>
                {{
                  new Date(data.value).toLocaleString('pe-PE', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    localeMatcher: 'best fit',
                    hour: '2-digit',
                    minute: '2-digit',
                    timeZone: 'America/Lima'
                  })
                }}
              </span>
            </template>
          </b-table>
        </b-card>
      </b-col>

    </b-row>

    <!-- Formulario para Registrar lo que se le entrega al trabajador -->
    <!-- FORMULARIO DE ENTREGA -->
    <b-modal
      id="modal-prevent-closing"
      modal-class="align-right-modal"
      v-model="modal_registro_entrega"
      title="Registro Entrega de Indumentaria al Trabajador"
      ok-title="Registrar"
      cancel-title="Cancelar"
      cancel-variant="outline-secondary"
      size="lg"
      :cancel-disabled="loading2"
      :ok-disabled="loading2"
      no-close-on-esc
      no-close-on-backdrop
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOkEntrega"
    >
      <div v-if="loading2"  align="center">
        <p>Registrando ... </p>
        <b-spinner label="Loading..." variant="primary"/>
      </div>
      <validation-observer v-else ref="formularioEntrega" #default="{invalid}">
        <b-form autocomplete="off" @submit.prevent="registrarEntrega">
          <b-row>
            <b-col lg="3">
              <b-form-group
                  label="DNI"
                  label-for="dni"
              >
                <validation-provider
                    #default="{ errors }"
                    name="dni"
                    vid="dni"
                    rules="required|integer|between:1,99999999"
                >
                  <b-form-input
                      id="dni"
                      v-model="dni"
                      :state="errors.length > 0 ? false:null"
                      name="dni"
                      ref="dniInput"
                      @input="buscarUbicacionIndumentaria"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group
                  label="CODIGO COLGADOR"
                  label-for="cod_asociado"
              >
                <validation-provider
                    #default="{ errors }"
                    name="cod_asociado"
                    vid="cod_asociado"
                    rules="required"
                >
                  <b-form-input
                      id="cod_asociado"
                      v-model="cod_asociado"
                      :state="errors.length > 0 ? false:null"
                      name="cod_asociado"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col> 
            <b-col lg="3">
              <b-form-group
                  label="INDUMENTARIAS: 2"
                  label-for="indumentaria"
              >
                <validation-provider
                    #default="{ errors }"
                    name="indumentaria"
                    vid="indumentaria"
                    rules="required"
                >
                  <v-select
                    id="indumentaria"
                    v-model="indumentaria"
                    :options="indumentarias"
                    label="text"
                    key="value"
                    placeholder="Selecciona indumentaria..."
                  >
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group
                  label="ESTADO"
                  label-for="estado"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estado"
                    vid="estado"
                    rules="required"
                >
                  <v-select
                      id="estado"
                      v-model="estado"
                      :options="estados"
                      label="text"
                      key="value"
                      placeholder="Selecciona estado..."
                  >
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col> 
            <b-col lg="8">
              <b-form-group
                  label="NOMBRES"
                  label-for="nombres"
              >
                <validation-provider
                    #default="{ errors }"
                    name="nombres"
                    vid="nombres"
                    rules="required"
                >
                  <b-form-input
                      id="nombres"
                      v-model="nombres"
                      :state="errors.length > 0 ? false:null"
                      name="nombres"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group
                label="CARGO"
                label-for="cargo"
              >
                <validation-provider
                    #default="{ errors }"
                    name="cargo"
                    vid="cargo"
                    rules="required"
                >
                  <b-form-input
                      id="cargo"
                      v-model="cargo"
                      :state="errors.length > 0 ? false:null"
                      name="cargo"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <b-form-group
                label="OBSERVACIONES DE ENTREGA"
                label-for="observaciones"
              >
                <validation-provider
                    #default="{ errors }"
                    name="observaciones"
                    vid="observaciones"
                    rules="required"
                >
                  <b-form-textarea
                      id="observaciones"
                      v-model="observaciones"
                      :state="errors.length > 0 ? false:null"
                      name="observaciones"
                      style="height:100px;max-height:100px"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>      
          </b-row>
        </b-form>
      </validation-observer>
    </b-modal>

    <!-- Formulario para Registrar lo que el trabajador entrega a la Estación -->
    <!-- FORMULARIO DE RECEPCION -->
    <b-modal
      modal-class="align-left-modal"
      v-model="modal_registro_devolucion"
      ref="my-modal"
      title="Registro Recepcion de Indumentaria del Trabajador"
      ok-title="Registrar"
      cancel-title="Cancelar"
      cancel-variant="outline-secondary"
      size="lg"
      :cancel-disabled="loading2"
      :ok-disabled="loading2"
      no-close-on-esc
      no-close-on-backdrop
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOkRecepcion"
    >
      <div v-if="loading2"  align="center">
        <p>Registrando ... </p>
        <b-spinner label="Loading..." variant="primary"/>
      </div>
      <validation-observer v-else ref="formularioRecepcion" #default="{invalid}">
        <b-form autocomplete="off" @submit.prevent="registrarRecepcion">
          <b-row>
            <b-col lg="3">
              <b-form-group
                  label="DNI"
                  label-for="dni_dos"
              >
                <validation-provider
                    #default="{ errors }"
                    name="dni_dos"
                    vid="dni_dos"
                    rules="required|integer|between:1,99999999"
                >
                  <b-form-input
                      id="dni_dos"
                      v-model="dni_dos"
                      :state="errors.length > 0 ? false:null"
                      name="dni_dos"
                      @input="buscarTrabajadorPorDni(true)"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group
                  label="CODIGO COLGADOR"
                  label-for="cod_asociado_dos"
              >
                <validation-provider
                    #default="{ errors }"
                    name="cod_asociado_dos"
                    vid="cod_asociado_dos"
                    rules="required"
                >
                  <b-form-input
                      id="cod_asociado_dos"
                      v-model="cod_asociado_dos"
                      :state="errors.length > 0 ? false:null"
                      name="cod_asociado_dos"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>  
            <b-col lg="3">
              <b-form-group
                label="INDUMENTARIA"
                label-for="indumentaria"
              >
                <validation-provider
                  #default="{ errors }"
                  name="indumentaria"
                  vid="indumentaria"
                  rules="required"
                >
                  <v-select
                    id="indumentaria"
                    v-model="indumentaria_dos"
                    :options="indumentarias"
                    label="text"
                    key="value"
                    placeholder="Selecciona indumentaria..."
                  >
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group
                  label="ESTADO"
                  label-for="estado"
              >
                <validation-provider
                    #default="{ errors }"
                    name="estado"
                    vid="estado"
                    rules="required"
                >
                  <v-select
                      id="estado"
                      v-model="estado_dos"
                      :options="estados"
                      label="text"
                      key="value"
                      placeholder="Selecciona estado..."
                  >
                    <span slot="no-options">No se encontraron datos.</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="8">
              <b-form-group
                  label="NOMBRES"
                  label-for="nombres_dos"
              >
                <validation-provider
                    #default="{ errors }"
                    name="nombres_dos"
                    vid="nombres_dos"
                    rules="required"
                >
                  <b-form-input
                      id="nombres_dos"
                      v-model="nombres_dos"
                      :state="errors.length > 0 ? false:null"
                      name="nombres_dos"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group
                label="CARGO"
                label-for="cargo_dos"
              >
                <validation-provider
                    #default="{ errors }"
                    name="cargo_dos"
                    vid="cargo_dos"
                    rules="required"
                >
                  <b-form-input
                      id="cargo_dos"
                      v-model="cargo_dos"
                      :state="errors.length > 0 ? false:null"
                      name="cargo_dos"
                      disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <b-form-group
                  label="OBSERVACIONES DE RECEPCION"
                  label-for="observaciones_dos"
              >
                <validation-provider
                    #default="{ errors }"
                    name="observaciones_dos"
                    vid="observaciones_dos"
                    rules="required"
                >
                  <b-form-textarea
                      id="observaciones_dos"
                      v-model="observaciones_dos"
                      :state="errors.length > 0 ? false:null"
                      name="observaciones_dos"
                      style="height:100px;max-height:100px"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>      
          </b-row>
        </b-form>
      </validation-observer>
    </b-modal>

    <b-modal
        id="modal-importar"
        ref="modal-importar"
        v-model="estadoModalImportar"
        title="Importar Datos Masivos"
        ok-title="Importar"
        cancel-title="Cancelar"
        cancel-variant="outline-secondary"
        size="md"
        :cancel-disabled="loadingIMP"
        :ok-disabled="loadingIMP||!archivo_excel"
        centered
        no-close-on-esc
        no-close-on-backdrop
        @show=""
        @hidden=""
        @ok="importarOk"
    >
      <div v-if="loadingIMP"  align="center">
        <p>Importando datos ... </p>
        <b-spinner label="Loading..." variant="primary"/>
      </div>
      <validation-observer v-else ref="formularioImportar" #default="{invalid}">
        <b-form autocomplete="off" @submit.prevent="enviarFile">
          <b-row>
            <b-col lg="12">
              <b-form-group
                  label="Archivo"
                  label-for="archivo"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Archivo"
                    vid="archivo"
                    rules="required"
                >
                  <b-form-file
                      id="archivo"
                      accept=".xlsx"
                      placeholder="Seleccionar Archivo Excel (.xlsx)"
                      v-model="archivo_excel"
                      ref="fileinput"
                  >
                    <template
                        slot="file-name"
                        slot-scope="{ names }"
                    >
                      <b-badge variant="primary">
                        {{ names[0] }}
                      </b-badge>
                    </template>
                  </b-form-file>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-modal>

    <b-modal
        id="modal-respuesta"
        ref="modal-respuesta"
        v-model="estadoModalRespuesta"
        title="Respuesta"
        ok-title="Aceptar"
        ok-only
        size="md"
        no-close-on-esc
        no-close-on-backdrop
        @show=""
        @hidden=""
        scrollable
    >
      <b-row>
        <b-col lg="12">
          <!-- <span>Se realizaron la creación de {{ respuestaRegistrosTotal }} registros satisfactoriamente.</span><br><br>
          <span>Se encontraron {{ respuestaErrores.length }} registros con errores:</span><br><br> -->
          <span>Se realizó la creación de registros satisfactoriamente.</span>
          <div
              v-for="error in respuestaErrores"
              :key="error.contador2"
          >
            <div class="mb-1">
              <span>Codigo homologado: {{ error.cod_homologado }}</span><br>
              <span>Error: {{ error.error }}.</span>
            </div>
          </div>


        </b-col>
      </b-row>
    </b-modal>

    <b-modal
        id="modal-seleccionar-estacion"
        ref="modal-seleccionar-estacion"
        v-model="estadoModalEstacion"
        title="Apertura de Estación"
        ok-title="Guardar"
        ok-only
        size="sm"
        centered
        no-close-on-esc
        no-close-on-backdrop
        hide-close-button
        :ok-disabled="!loadingEST"
        @show=""
        @hidden=""
    >
      <b-row>
        <b-col lg="12">
          <validation-provider
            #default="{ errors }"
            name="Estacion"
            vid="estacion"
            rules="required"
          >
            <v-select
              id="estacion"
              v-model="estacion"
              :options="estaciones"
              :reduce="estaciones => estaciones.value"
              label="text"
              key="value"
              placeholder="Por favor seleccionar la estación de trabajo"
              class="mb-9 mt-1"
              @input="actualizarEstacion" 
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
          <br>
        </b-col>
      </b-row>
    </b-modal>

    <!-- --------------MODAL EDITAR--------i -->
    <b-modal
        id="modal-select2"
        v-model="modalEditarEstadoShow"
        no-close-on-esc
        no-close-on-backdrop
        cancel-variant="secondary"
        ok-title="Actualizar"
        :ok-disabled="!estado_aprobar"
        cancel-title="Cancelar"
        centered
        title="Autorizar registro"
        @ok=""
    >
      <b-form>
        <b-form-group
            label="Estado"
            label-for="estado_editar"
        >
          <v-select
              id="estado_editar"
              v-model="estado_aprobar"
              :options="estados"
              :reduce="estados => estados.value"
              label="text"
              key="value"
              placeholder="Seleccionar estado..."
          />
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>

<script>

import axiosIns from '../../libs/axios'
import vSelect from 'vue-select'
import {
  BBadge,
  BButton,
  BCard,
  BCardBody,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BModal,
  BPagination,
  BSpinner,
  BTable,
  BRow,
  BCol,
  BDropdownDivider,
  BFormFile,
  VBModal,
  BTooltip,
  BInputGroup,
  BFormDatepicker,
  BFormTimepicker,
  BInputGroupAppend,
  BInputGroupPrepend, BFormTextarea, BLink, BButtonGroup,
  BAlert, VBTooltip,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required, double, max, between, integer } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent'


export default {
  components: {
    BCard,
    BCardBody,
    BTable,
    BSpinner,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BButton,
    BFormInput,
    BModal,
    VBModal,
    BForm,
    BCol,
    BRow,
    BDropdownDivider,
    BFormFile,
    BTooltip,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend,
    BFormTextarea,
    BLink,
    BFormDatepicker,
    BFormTimepicker,
    BButtonGroup,
    BAlert,

    vSelect,

    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
  },
  data: () => ({
    id_user: JSON.parse(localStorage.getItem('userData')).id,

    dias: null,
    estacion:'',
    estaciones:[
      {value:'1',text:'Estación 1'},
      {value:'2',text:'Estación 2'},
      {value:'3',text:'Estación 3'},
      {value:'4',text:'Estación 4'},
      {value:'5',text:'Estación 5'},
      {value:'6',text:'Estación 6'},
      {value:'7',text:'Estación 7'},
      {value:'8',text:'Estación 8'},
      {value:'9',text:'Estación 9'},
    ],
    dni:'',
    estado:'Pendiente',
    nombres:'',
    cod_asociado:'',
    area:'',
    cargo:'',
    packing:'',
    observaciones:'',
    indumentaria:'',
    indumentarias:[
      {value:'CASACA',text:'CASACA'},
      {value:'PANTALON',text:'PANTALON'},
      {value:'PRENDA 3',text:'PRENDA 3'},
    ],
    dni_dos:'',
    estado_dos:'Atendido',
    nombres_dos:'',
    cod_asociado_dos:'',
    cargo_dos:'',
    area_dos:'CALIDAD',
    packing_dos:'PALTA',
    observaciones_dos:'',
    indumentaria_dos:'CASACA',
    
    modal_registro_entrega: false,
    modal_registro_devolucion: false,
    loadingEST: false,

    submittedNames: [],
    loading: false,
    loading2: false,
    loadingBP: false,
    loadingDE: false,
    loadingIMP: false,
    loadingEDI: false,

    loadingSAC: false,
    loadingSSC: false,
    loadingSSM: false,
    loadingSAM: false,
    loadingSAD: false,
    loadingSSD: false,

    estadoModalEditar: false,
    estadoModalImportar: false,
    estadoModalEstacion:true,
    estadoModalRespuesta: false,

    modalEditarEstadoShow: false,
    items: [],
    items_completo: [],
    perPage: 5,
    pageOptions: [5, 10, 15, 30],
    totalRows: 0,
    currentPage: 1,
    sortBy: 'id',
    sortDesc: true,
    sortDirection: 'desc',
    filter: null,
    filter_sig: null,
    filterOn: ['accion'],
    fields: [
      {
        key: 'acciones',
        label: '# ',
        class: 'text-nowrap text-center',
        stickyColumn: true,
      },
      {
        key: 'estado',
        label: 'proceso',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'dni',
        label: 'dni',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'cod_asociado',
        label: 'cod_asociado',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'nombres',
        label: 'nombres',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'cargo',
        label: 'cargo',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'accion',
        label: 'estado',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      // {
      //   key: 'fecha_hora_escaneo',
      //   label: 'fecha_hora_escaneo',
      //   class: 'text-nowrap text-center',
      //   sortable: true,
      // },
      // {
      //   key: 'fecha_hora_registro',
      //   label: 'fecha_hora_registro',
      //   class: 'text-nowrap text-center',
      //   sortable: true,
      // },

    ],

    fields_detalle_SemAct: [
      {
        key: 'acciones',
        label: '# ',
        class: 'text-nowrap text-center',
      },
      {
        key: 'estado',
        label: 'estado',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'etapa',
        label: 'etapa',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'campo',
        label: 'campo',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'turno',
        label: 'turno',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'variedad',
        label: 'variedad',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'lote',
        label: 'lote',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'valvula',
        label: 'válvula',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'area',
        label: 'área',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'eto',
        label: 'ETO',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'kc',
        label: 'KC',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'lr_dia',
        label: 'LR/Dia',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'descarga_caudal_hora',
        label: 'Descarga Caudal/Hora (m3/Ha)',
        class: 'text-nowrap text-center',
        sortable: true,
      },

      {
        key: 'volumen',
        label: 'Volumen Total/Dia/Turno',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'ciclos_riego',
        label: 'Ciclos de Riego',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'riego_total',
        label: 'Riego Total',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'horas',
        label: 'Horas',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'riego_cortina',
        label: 'Riego Cortina',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'con_sin_fertilizante',
        label: 'Con/Sin Fertilizante',
        class: 'text-nowrap text-center',
        sortable: true,
      },

      {
        key: 'ciclo_1',
        label: 'Ciclo I',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'estanque_uno_1',
        label: 'Estanque 1',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'estanque_dos_1',
        label: 'Estanque 2',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'estanque_tres_1',
        label: 'Estanque 3',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'hora_inicio_1',
        label: 'Hora de Inicio',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'horas_inicio_seg_ciclo',
        label: 'Horas para Inicio de 2° Ciclo',
        class: 'text-nowrap text-center',
        sortable: true,
      },

      {
        key: 'ciclo_2',
        label: 'Ciclo II',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'estanque_uno_2',
        label: 'Estanque 1',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'estanque_dos_2',
        label: 'Estanque 2',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'estanque_tres_2',
        label: 'Estanque 3',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'hora_inicio_2',
        label: 'Hora de Inicio',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'horas_inicio_ter_ciclo',
        label: 'Horas para Inicio de 3° Ciclo',
        class: 'text-nowrap text-center',
        sortable: true,
      },

      {
        key: 'ciclo_3',
        label: 'Ciclo III',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'estanque_uno_3',
        label: 'Estanque 1',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'estanque_dos_3',
        label: 'Estanque 2',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'estanque_tres_3',
        label: 'Estanque 3',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'hora_inicio_3',
        label: 'Hora de Inicio',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'comentarios',
        label: 'Comentarios',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'cod_homologado',
        label: 'Cod.  Homologado',
        class: 'text-nowrap text-center',
        sortable: true,
      },



        /*
      {
        key: 'created',
        label: 'Fecha - Hora',
        class: 'text-nowrap text-center',
        sortable: true,
      },
        */
    ],

    espanol:{
      labelNoTimeSelected: 'Seleccione Hora',
    },

    status_uno: [
      // {
      //   0: 'Pendiente',
      //   1: 'Revisado',
      //   2: 'Aprobado',
      //   3: 'Desaprobado',
      //   4: 'Eliminado',
      // },
      // {
      //   0: 'light-info',
      //   1: 'light-warning',
      //   2: 'light-success',
      //   3: 'light-danger',
      //   4: 'light-dark',
      // }
      {
        0: 'Pendiente',
        1: 'Atendido',
        2: 'Aprobado',
        3: 'Desaprobado',
        4: 'Eliminado',
      },
      {
        0: 'light-info',
        1: 'light-success',
        2: 'light-warning',
        3: 'light-danger',
        4: 'light-dark',
      },

    ],

    status_dos: [
      {
        'E': 'Entregado',
        'R': 'Recepcionado',
      },
      {
        'E': 'light-danger',
        'R': 'light-warning',
      }
    ],


    estados: [
      {value: '0', text: "Pendiente"},
      {value: '1', text: "Atendido"},
      /*
      {value: '1', text: "Observar"},
      {value: '3', text: "Desaprobar"}
       */
    ],

    parametros_usuario: [],

    estado_aprobar: null,

    archivo_excel: null,
    empresas: [],
    cultivos: [],
    cultivosIMP: ['ARANDANO', 'ESPÁRRAGO', 'PALTA', 'UVA'],
    fundos: [],
    etapas: [],
    campos: [],
    turnos: [],
    codigos_h: [],
    parametros: [],

    dataEmpresa: [],
    dataLotesValvulas: [],
    notDuplicados: [],
    dataCompleta: [],

    spd: [],
    dia: null,
    hora: null,
    // -------

    comentario: null,

    semana_sig: null,
    inicioSemana_sig: null,
    finSemana_sig: null,

    mostrarSemAct: false,
    mostrarSemSgte: false,
    items_sem_act: [],
    items_sem_sgte: [],
    responsable: [],

    dataAutorizar:null,

    semanaActual: true,
    semanaEnviar: null,

    mostrarAlert: false,
    mostrarAlert2: false,

    respuestaRegistrosTotal: 0,
    respuestaErrores: [],



    // validation rules
    required,
    double,
    max,
    between,
    integer,
  }),
  computed: {},
  async mounted() {
    this.estadoModalEstacion=false;
    this.obtenerRegsEntregaRecepcionIndumentaria();

    await this.dataInicial();
    localize("es");
  },
  methods: {

    obtenerRegsEntregaRecepcionIndumentaria(){
      console.log("OBTENIENDO REGISTROS DE LA BASE DATOS")
      const yo=this
      const config={
        method: 'get',
        url: '/elli/indumentaria/obtenerRegsEntregaRecepcionIndumentaria/',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
      }

      axiosIns(config)
        .then(function(response){
          if(response.status==200){
            console.log(response.data)
            yo.items = response.data;
            
            // for(let i of yo.items){
            //   if(i['accion']=='R'){
            //     i['accion']='Recepcionado'
            //   }else if(i['accion']=='E'){
            //     i['accion']='Entregado'
            //   }
            // }

            yo.totalRows = yo.items.length
          }
        })
    },

    buscarTrabajadorPorDni(accion){
      console.log("CONSULTANDO TRABAJADOR POR DNI")
      const yo=this;
      let documento;

      console.log(accion)
      if (accion==true){
        documento=yo.dni_dos

      }else{
        documento=yo.dni
      }

      const data = JSON.stringify(
        {
          'documento': documento,
        }
      )

      console.log(data)

      const config={
        method: 'post',
        url: '/elli/indumentaria/consultarDatosTrabajador/',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: data
      }

      axiosIns(config)
        .then(function(response){
          if(response.status==200){
            console.log(response.data[0])

            yo.nombres_dos=response.data[0]['nombres']
            yo.cargo_dos=response.data[0]['cargo']
            yo.indumentaria_dos=response.data[0]['implemento']
          }
        })
      
    },

    buscarUbicacionIndumentaria(){
      console.log("CONSULTANDO UBICACION DE INDUMENTARIA...")
      const yo=this
      
      let documento=yo.dni
      const data = JSON.stringify(
        {
          'documento': documento,
        }
      )

      console.log(data)
      
      const config={
        method: 'post',
        url: '/elli/indumentaria/consultarUbicacionIndumentaria/',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: data
      }

      axiosIns(config)
        .then(function(response){
          if(response.status==200){
            console.log("PROCESANDO RESPUESTA DE UBICACION DE INDUMENTARIA...")
            console.log(response.data)
            
            if(response.data['datos_colaborador']){ //
              
              console.log("No se encontró registros con ese dni en tabla el_regcontrol_indumentaria")
              yo.cod_asociado="PRIMERA ENTREGA"
              yo.nombres=response.data['datos_colaborador'][0]['nombre_completo']
              yo.cargo=response.data['datos_colaborador'][0]['denominacion_objeto']
              yo.estado='Atendido'

            }else{
              yo.indumentarias=[] //Reseteo select de indumentaria
              yo.cod_asociado= response.data[0]['cod_asociado']
              yo.nombres=response.data[0]['nombres']
              yo.cargo=response.data[0]['cargo']
              yo.indumentaria=response.data[0]['implemento']

              if(response.data[0]['estado']==0){
                yo.estado='Pendiente'
              }else if(response.data[0]['estado']==1){
                yo.estado='Atendido'
              }
            }

          }
        })
    },

    actualizarEstacion(){
      console.log("ACTUALIZANDO ESTACION")
      const yo=this

      if (yo.estacion ==''){
        yo.loadingEST=false
      }else{
        yo.loadingEST=true
      }

      document.getElementById('n_estacion').innerHTML=this.estacion
    },

    dataInicial(){
      const spd = this.numeroDeSemana(new Date())
      this.semana = spd.n_semana.toString().padStart(2, '0')
      this.inicioSemana = spd.inicio.toLocaleString('pe-PE', {
        month: 'long',
        day: '2-digit',
        year: 'numeric',
        localeMatcher: 'best fit',
        timeZone: 'America/Lima'
      })
      this.finSemana = spd.fin.toLocaleString('pe-PE', {
        month: 'long',
        day: '2-digit',
        year: 'numeric',
        localeMatcher: 'best fit',
        timeZone: 'America/Lima'
      })

      this.semana_sig = spd.n_semana === 52 ? '01' : (spd.n_semana + 1).toString().padStart(2, '0')
      // this.semana_sig = spd.n_semana + 1
      spd.inicio.setDate(spd.inicio.getDate() + 7)
      spd.fin.setDate(spd.fin.getDate() + 7)

      this.inicioSemana_sig = spd.inicio.toLocaleString('pe-PE', {
        month: 'long',
        day: '2-digit',
        year: 'numeric',
        localeMatcher: 'best fit',
        timeZone: 'America/Lima'
      })
      this.finSemana_sig = spd.fin.toLocaleString('pe-PE', {
        month: 'long',
        day: '2-digit',
        year: 'numeric',
        localeMatcher: 'best fit',
        timeZone: 'America/Lima'
      })

      this.filter = this.semana
      this.filter_sig = this.semana_sig

    },

    cPaginacion(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    registrarEntrega(){
      this.$refs.dniInput.focus();
      console.log("XXKKKKKKKKKKK")
      const yo= this
      this.$refs.formularioEntrega.validate().then(success => {
      
        yo.loading2 = true

        if (yo.indumentaria['value']){
          yo.indumentaria=yo.indumentaria['value']
        }

        if (yo.estado['value']){
          yo.estado=yo.estado['value']
        }else{
          if (yo.estado='Atendido'){
            yo.estado=1
          }
          else{
            yo.estado_dos=0
          }
        }
        
        const data = JSON.stringify({
          'dni': yo.dni,
          'cod_asociado': yo.cod_asociado,
          'indumentaria': yo.indumentaria,
          'estado': yo.estado,
          'nombres': yo.nombres,
          'cargo':yo.cargo,
          'observaciones': yo.observaciones,
          'estacion': yo.estacion,
          'usuario_registrador':yo.id_user,
          'accion':'E'
        })

        const config = {
          method: 'post',
          url: '/elli/indumentaria/registrarEntregaIndumentariaEnEstacion/',
          headers: {
            'Content-Type': 'application/json'
          },
            data: data
        }

        axiosIns(config)
          .then(function (response) {

            if (response.status === 200 ){
              yo.mostrarNotificacion('¡Bien hecho!', 'CheckIcon', "El registro se realizó de manera correcta", 'success', 5000)
            }

          })
          .catch(function (error) {
            console.log(error);
            yo.mostrarNotificacion('Error en el registro', 'BellIcon', error.toString(), 'danger', 5000)
          })
          .finally(function (){
            yo.loading2 = false
          })

          console.log("TERMINO DE REGISTRAR ENTREGA")
          yo.resetModal();
          yo.obtenerRegsEntregaRecepcionIndumentaria();
          
        })
    },

    registrarRecepcion(){
      const yo=this
      this.$refs.formularioRecepcion.validate().then(success => {
        yo.loading2=true

        if (yo.indumentaria_dos['value']){
          yo.indumentaria_dos=yo.indumentaria_dos['value']
        }

        if (yo.estado_dos['value']){
          yo.estado_dos=yo.estado_dos['value']
        }else{
          if (yo.estado_dos='Atendido'){
            yo.estado_dos=1
          }
          else{
            yo.estado_dos=0
          }
        }

        const data = JSON.stringify({
          'dni': yo.dni_dos,
          'cod_asociado': yo.cod_asociado_dos,
          'indumentaria': yo.indumentaria_dos,
          'estado': yo.estado_dos,
          'nombres': yo.nombres_dos,
          'cargo':yo.cargo_dos,
          'observaciones': yo.observaciones_dos,
          'estacion': yo.estacion,
          'usuario_registrador':yo.id_user,
          'accion':'R'
        })

        const config = {
          method: 'post',
          url: '/elli/indumentaria/registrarRecepcionIndumentariaEnEstacion/',
          headers: {
            'Content-Type': 'application/json'
          },
            data: data
        }

        axiosIns(config)
          .then(function (response) {

            if (response.status === 200 ){
              yo.mostrarNotificacion('¡Bien hecho!', 'CheckIcon', "El registro se realizó de manera correcta", 'success', 5000)
            }

          })
          .catch(function (error) {
            console.log(error);
            yo.mostrarNotificacion('Error en el registro', 'BellIcon', error.toString(), 'danger', 5000)
          })
          .finally(function (){
            yo.loading2 = false
          })

          yo.resetModal();
          yo.obtenerRegsEntregaRecepcionIndumentaria();

      })
    },

    // registrarRecepcion() {
    //   const yo = this
    //   console.log("JIIJI")
    //   this.$refs.formularioRecepcion.validate().then(success => {
    //     if (success && !yo.mostrarAlert && !yo.mostrarAlert2)  {
    //       yo.loading2 = true

    //       if (yo.indumentaria_dos['value']){
    //         yo.indumentaria_dos=yo.indumentaria_dos['value']
    //       }
          
    //       if (yo.estado_dos['value']){
    //         yo.estado_dos=yo.estado_dos['value']
    //       }else{
    //         if (yo.estado_dos='Atendido'){
    //           yo.estado_dos=1
    //         }
    //         else{
    //           yo.estado_dos=0
    //         }
    //       }

    //       const data = JSON.stringify({
    //         'dni': yo.dni_dos,
    //         'cod_asociado': yo.cod_asociado_dos,
    //         'indumentaria': yo.indumentaria_dos,
    //         'estado': yo.estado_dos,
    //         'nombres': yo.nombres_dos,
    //         'cargo':yo.cargo_dos,
    //         'observaciones': yo.observaciones_dos,
    //         'estacion': yo.estacion,
    //         'usuario_registrador':yo.id_user,
    //         'accion':'R'
    //       })

    //       const config = {
    //         method: 'post',
    //         url: '/elli/indumentaria/registrarRecepcionIndumentariaEstacion/',
    //         headers: {
    //           'Content-Type': 'application/json'
    //         },
    //           data: data
    //       }

    //       axiosIns(config)
    //         .then(function (response) {

    //           if (response.status === 200 ){
    //             yo.mostrarNotificacion('¡Bien hecho!', 'CheckIcon', "El registro se realizó de manera correcta", 'success', 5000)
    //           }

    //         })
    //         .catch(function (error) {
    //           console.log(error);
    //           yo.mostrarNotificacion('Error en el registro', 'BellIcon', error.toString(), 'danger', 5000)
    //         })
    //         .finally(function (){
    //           yo.loading2 = false
    //         })

    //         yo.resetModal();
    //         yo.obtenerRegsEntregaRecepcionIndumentaria();
    //     }
    //   })
    // },

    editarRegistro(){
      const yo = this
      
      this.$refs.formularioEditarRiego.validate().then(success => {
        if (success){
          yo.loadingEditar = true
          
          const data = JSON.stringify({
            'semana': yo.semanaActual ? yo.semana : yo.semana_sig,
            'fundo': yo.fundo,
            'cultivo': yo.cultivo,
            'etapa': yo.etapa,
            'empresa': yo.empresa,
            'campo': yo.campo,
            'turno': yo.turno,
            'cod_homologado':yo.codigo_h.codigo_h,
          
            'variedad': yo.variedad,
            'lote': yo.lote,
            'valvula': yo.valvula,
            'area': yo.area,

            'eto': yo.eto,
            'kc': yo.kc,
            'lr_dia':yo.lr_dia,
            'descarga_caudal_hora':yo.descarga_caudal_hora,

            'volumen':yo.volumen,
            'ciclos_riego':yo.ciclos_riego,
            'riego_total':yo.riego_total,
            'horas':yo.horas,
            'riego_cortina':yo.riego_cortina,
            'con_sin_fertilizante':yo.con_sin_fertilizante,

            'ciclo_1':yo.ciclo_1,
            'estanque_uno_1':yo.estanque_uno_1,
            'estanque_dos_1':yo.estanque_dos_1,
            'estanque_tres_1':yo.estanque_tres_1,
            'hora_inicio_1':yo.hora_inicio_1,
            'horas_inicio_seg_ciclo':yo.horas_inicio_seg_ciclo,

            'ciclo_2':yo.ciclo_2,
            'estanque_uno_2':yo.estanque_uno_2,
            'estanque_dos_2':yo.estanque_dos_2,
            'estanque_tres_2':yo.estanque_tres_2,
            'hora_inicio_2':yo.hora_inicio_2,
            'horas_inicio_ter_ciclo':yo.horas_inicio_ter_ciclo,

            'ciclo_3':yo.ciclo_3,
            'estanque_uno_3':yo.estanque_uno_3,
            'estanque_dos_3':yo.estanque_dos_3,
            'estanque_tres_3':yo.estanque_tres_3,
            'hora_inicio_3':yo.hora_inicio_3,
            'comentarios':yo.comentarios,
            'estado': '0',
            'con_usuario': yo.id_user,

          })

          const config = {
            method: 'put',
            url: 'riego/editar/'+yo.id_editar,
            headers: {
              'Content-Type': 'application/json'
            },
            data: data
          }


          axiosIns(config)
            .then(function (response) {
              if (response.status === 200){
                yo.mostrarNotificacion('¡Bien hecho!', 'CheckIcon', "El registro se editó de manera correcta", 'success', 5000)
              }
            })
            .catch(function (error) {
              console.log(error);
              yo.mostrarNotificacion('Error en la edición', 'BellIcon', 'Error: \n '+error.toString(), 'danger', 5000)
            })
            .finally(function (){
              yo.mostrarSemAct=false
              yo.mostrarSemSgte=false
          
              yo.$nextTick(() => {
                yo.$refs['modal-editar'].toggle('#toggle-btn')
              })
              yo.loadingEditar = false
            })

        }
      })
    },

    resetModal() {

      console.log("MMMMMMMMMMMMM")
      const yo=this

      yo.dni=null
      yo.cod_asociado=null
      yo.estado='Atendido'
      yo.indumentaria=null
      yo.nombres=null
      yo.cargo=null
      yo.observaciones=null
      yo.indumentarias=[
        {value:'CASACA',text:'CASACA'},
        {value:'PANTALON',text:'PANTALON'},
        {value:'PRENDA 3',text:'PRENDA 3'},
      ]

      yo.dni_dos=null
      yo.cod_asociado_dos=null
      yo.indumentaria_dos='CASACA'
      yo.estado_dos='Atendido'
      yo.nombres_dos=null
      yo.cargo_dos=null
      yo.observaciones_dos=null     

    },

    handleOkRecepcion(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.registrarRecepcion()
    },

    handleOkEntrega(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.registrarEntrega()
    },

    validarRegistroEditar(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.editarRegistro()
    },

    importarOk(bvModalEvtImp) {
      // Prevent modal from closing
      bvModalEvtImp.preventDefault()
      // Trigger submit handler
      this.enviarFile()
    },

    mostrarNotificacion(titulo, icono, texto, variante, tiempo){
      this.$toast({
            component: ToastificationContent,
            props:{
              title: titulo,
              icon: icono,
              text: texto,
              variant: variante
            }
          },
          {
            timeout: tiempo,
            position: 'top-center',
          })
    },

    comporbarExcedente(){

      const suma = parseFloat(this.lunes) + parseFloat(this.martes) + parseFloat(this.miercoles) + parseFloat(this.jueves) + parseFloat(this.viernes) + parseFloat(this.sabado) + parseFloat(this.domingo)
      const resultado = (suma / parseInt(this.dias)).toLocaleString('es-PE', {maximumFractionDigits: 5})

      this.mostrarAlert = resultado !== this.total_max_dia;

      let c = 0

      c = parseFloat(this.lunes) !== 0 ? c+1 : c
      c = parseFloat(this.martes) !== 0 ? c+1 : c
      c = parseFloat(this.miercoles) !== 0 ? c+1 : c
      c = parseFloat(this.jueves) !== 0 ? c+1 : c
      c = parseFloat(this.viernes) !== 0 ? c+1 : c
      c = parseFloat(this.sabado) !== 0 ? c+1 : c
      c = parseFloat(this.domingo) !== 0 ? c+1 : c

      this.mostrarAlert2 = c !== parseInt(this.dias);

    },

    numeroDeSemana(fecha){
      const DIA_EN_MILISEGUNDOS = 1000 * 60 * 60 * 24, DIAS_QUE_TIENE_UNA_SEMANA = 7, JUEVES = 4;

      // fecha = new Date(Date.UTC(fecha.getFullYear(), fecha.getMonth(), fecha.getDate()+7));
      fecha = new Date(Date.UTC(fecha.getFullYear(), fecha.getMonth(), fecha.getDate()));

      let diaDeLaSemana = fecha.getUTCDay(); // Domingo es 0, sábado es 6
      if (diaDeLaSemana === 0) {
        diaDeLaSemana = 7;
      }

      fecha.setUTCDate(fecha.getUTCDate() - diaDeLaSemana + JUEVES);

      const inicioDelAnio = new Date(Date.UTC(fecha.getUTCFullYear(), 0, 1));

      const diferenciaDeFechasEnMilisegundos = fecha - inicioDelAnio;

      return {
        n_semana: Math.ceil(((diferenciaDeFechasEnMilisegundos / DIA_EN_MILISEGUNDOS) + 1) / DIAS_QUE_TIENE_UNA_SEMANA),
        inicio: new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate() - fecha.getDay() + 1),
        fin: new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate() + 7 - fecha.getDay()),
      }

    },

    asignarInicioFinSemana(){
      this.inicioSemana = ''
      this.finSemana = ''

      if (this.semana >= 1 && this.semana <= 52){
        const hoy = new Date()
        const fech = new Date(Date.UTC(hoy.getFullYear(), 0, 1));

        fech.setDate(fech.getDate() + (this.semana*7));

        const inicio = new Date(fech.getFullYear(), fech.getMonth(), fech.getDate() - fech.getDay() + 1)
        const fin = new Date(fech.getFullYear(), fech.getMonth(), fech.getDate() + 7 - fech.getDay())

        this.inicioSemana = inicio.toLocaleString('pe-PE', {
          month: 'long',
          day: '2-digit',
          year: 'numeric',
          localeMatcher: 'best fit',
          timeZone: 'America/Lima'
        })
        this.finSemana = fin.toLocaleString('pe-PE', {
          month: 'long',
          day: '2-digit',
          year: 'numeric',
          localeMatcher: 'best fit',
          timeZone: 'America/Lima'
        })
      }
    },

    enviarFile(){
      const yo = this
      this.$refs.formularioImportar.validate().then(success => {
        if (success) {
          this.loadingIMP = true
          const data = new FormData();
          data.append('file', yo.archivo_excel)
          data.append('con_usuario', yo.id_user)
          data.append('semana', yo.semanaEnviar)
          data.append('parametros_usuario', JSON.stringify(yo.parametros_usuario))

          const config = {
            method: 'post',
            url: '/riego/importar/filter/',
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            data: data
          }

          axiosIns(config)
              .then(function (response) {
                if(response.status === 200){
                    
                  // yo.respuestaRegistrosTotal = response.data['total']
                  // yo.respuestaErrores = response.data['errores']
                  yo.mostrarNotificacion('¡Bien hecho!', 'CheckIcon', "La importación se realizó correctamente", 'success', 5000)

                }
              })
              .catch(function (error) {
                console.log(error);

                yo.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Error en el registro',
                    icon: 'XIcon',
                    text: 'Hubo un error en el registro, intentelo nuevamente en unos minutos.',
                    variant: 'danger',
                  },
                })
              })
              .finally(function () {
                yo.archivo_excel = null
                yo.cultivoIMP = null
                yo.loadingIMP = false
                yo.$nextTick(() => {
                  yo.$refs['modal-importar'].toggle('#toggle-btn')
                })

                // yo.estadoModalRespuesta = true
              })
        }
      })
    },

    autorizar(data){
      this.estado_aprobar = null

      if(data['estado'] === '0'){
        this.modalEditarEstadoShow = true
        this.dataAutorizar = data.semana + "*" + data.cultivo + "*" + data.empresa + "*" + data.fundo + "*" + data.version
      }else{
        if(this.responsable[0].rol === 'USUARIO'){
          this.mostrarNotificacion('Advertencia', 'BellIcon', "Solo se pueden seleccionar los registro con aprobación pendiente.", 'warning', 6000)
        }else{
          this.modalEditarEstadoShow = true
          this.dataAutorizar = data.semana + "*" + data.cultivo + "*" + data.empresa + "*" + data.fundo + "*" + data.version
        }
      }
    },

    verDetalle(datos){
      console.log(datos)
      const yo = this
      yo.items_sem_act = yo.spd.filter(invoice => invoice.semana+invoice.cultivo+invoice.empresa+invoice.fundo === datos.semana+datos.cultivo+datos.empresa+datos.fundo)

      yo.mostrarSemAct = true
    },

    verDetalleSemSgte(datos){
      const yo = this
      yo.items_sem_sgte = yo.spd.filter(invoice => invoice.semana+invoice.cultivo+invoice.empresa+invoice.fundo === datos.semana+datos.cultivo+datos.empresa+datos.fundo)

      yo.mostrarSemSgte = true
    },

    descargarPlantilla(){
      const yo = this
      const config = {
        method: 'get',
        url: '/fertilizacion/plantilla/',
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'arraybuffer'
      }

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {

              const fileURL = window.URL.createObjectURL(new Blob([response.data]))
              const fileLink = document.createElement('a')
              fileLink.href = fileURL;
              fileLink.setAttribute('download', 'Plantilla_PRG_AGR.xlsx');
              document.body.appendChild(fileLink);
              fileLink.click();

              yo.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Archivo creado',
                      icon: 'CheckIcon',
                      text: 'El archivo se creó satisfactoriamente.',
                      variant: 'success',
                    },
                  },
                  {
                    position: 'top-center',
                  })
            }
          })
          .catch(function (error) {
            console.log(error);
            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error en la creación del archivo',
                icon: 'XIcon',
                text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                variant: 'danger',
              },
            })
          });
    },

    mostrarModalEditar(datos){
      

      const yo = this
      yo.estadoModalEditar = true
      yo.id_editar = datos['id']
      yo.semana = datos['semana']
      yo.empresa = datos['empresa']

      this.asignarCultivos()
      yo.cultivo = datos['cultivo']
      this.asignarFundos()
      yo.fundo = datos['fundo']
      this.asignarEtapas()
      yo.etapa = datos['etapa']
      this.asignarCampos()
      yo.campo = datos['campo']
      this.asignarTurnos()
      yo.turno = datos['turno']
      this.asignarCodigos()

      yo.codigo_h=datos['cod_homologado']
      
      yo.variedad = datos['variedad']
      yo.lote = datos['lote']
      yo.valvula = datos['valvula']
      yo.area = datos['area']
      
      yo.eto = datos['eto']
      yo.kc = datos['kc']
      yo.lr_dia = datos['lr_dia']
      yo.descarga_caudal_hora = datos['descarga_caudal_hora']

      yo.volumen = datos['volumen']
      yo.ciclos_riego = datos['ciclos_riego']
      yo.riego_total = datos['riego_total']
      yo.horas = datos['horas']
      yo.riego_cortina = datos['riego_cortina']
      yo.con_sin_fertilizante = datos['con_sin_fertilizante']

      yo.ciclo_1 = datos['ciclo_1']
      yo.estanque_uno_1 = datos['estanque_uno_1']
      yo.estanque_dos_1 = datos['estanque_dos_1']
      yo.estanque_tres_1 = datos['estanque_tres_1']
      yo.hora_inicio_1 = datos['hora_inicio_1']
      yo.horas_inicio_seg_ciclo = datos['horas_inicio_seg_ciclo']

      yo.ciclo_2 = datos['ciclo_2']
      yo.estanque_uno_2 = datos['estanque_uno_2']
      yo.estanque_dos_2 = datos['estanque_dos_2']
      yo.estanque_tres_2 = datos['estanque_tres_2']
      yo.hora_inicio_2 = datos['hora_inicio_2']
      yo.horas_inicio_ter_ciclo = datos['horas_inicio_ter_ciclo']

      yo.ciclo_3 = datos['ciclo_3']
      yo.estanque_uno_3 = datos['estanque_uno_3']
      yo.estanque_dos_3 = datos['estanque_dos_3']
      yo.estanque_tres_3 = datos['estanque_tres_3']
      yo.hora_inicio_3 = datos['hora_inicio_3']
      yo.comentarios = datos['comentarios']
  
    },

    mostrarModalImportar(valor){

      const yo = this
      const config = {
        method: 'get',
        url: '/parametrosCompleto/?cod=' + yo.id_user
      }

      yo.loadingSAM = valor
      yo.loadingSSM = !valor

      axiosIns(config)
          .then(function (response) {
            if(response.status === 200){
              yo.parametros_usuario = response.data['usuario'][0]
              const parametros_total = response.data['parametros'].filter(
                  invoice => invoice.id === 4
              );
              const parametros_actual = response.data['parametros'].filter(
                  invoice => invoice.id === 5
              );
              const parametros_sgte = response.data['parametros'].filter(
                  invoice => invoice.id === 6
              );

              if(parametros_total[0]['estado'] === '0'){
                yo.parametros = parametros_total
              }
              else if (valor){
                if(parametros_actual[0]['estado'] === '0'){
                  yo.parametros = parametros_actual
                }else{
                  yo.parametros = [{
                    'valor': response.data['usuario'][0]['valor'],
                    'valor2': response.data['usuario'][0]['valor_1']
                  }]

                }
              }
              else{
                if(parametros_sgte[0]['estado'] === '0'){
                  yo.parametros = parametros_sgte
                }else{
                  yo.parametros = [{
                    'valor': response.data['usuario'][0]['valor_2'],
                    'valor2': response.data['usuario'][0]['valor_3']
                  }]
                }
              }

              yo.semanaEnviar = valor ? yo.semana : yo.semana_sig

              yo.dia = yo.parametros[0]['valor']
              yo.hora = yo.parametros[0]['valor2']

              let valorDia = 0

              const horaInicial = yo.hora.split(':')

              if(yo.dia === 'LUNES'){
                valorDia = 1
              }else if(yo.dia === 'MARTES'){
                valorDia = 2
              }else if(yo.dia === 'MIÉRCOLES'){
                valorDia = 3
              }else if(yo.dia === 'JUEVES'){
                valorDia = 4
              }else if(yo.dia === 'VIERNES'){
                valorDia = 5
              }else if(yo.dia === 'SÁBADO'){
                valorDia = 6
              }else if(yo.dia === 'DOMINGO'){
                valorDia = 7
              }

              const ahora = new Date()

              const fechaInicial = new Date(ahora.getUTCFullYear(), ahora.getUTCMonth(),ahora.getUTCDate(), parseInt(horaInicial[0]), parseInt(horaInicial[1]), parseInt(horaInicial[2]))

              if (ahora.getDay() < valorDia){
                yo.estadoModalImportar = true
              }
              else if (ahora.getDay() === valorDia){
                if(ahora <= fechaInicial){
                  yo.estadoModalImportar = true
                }else{
                  yo.mostrarNotificacion('¡Advertencia!', 'BellIcon', "No pueden agregar nuevos registros porque se encuentra fuera del límite programado.", 'warning', 5000)
                }
              }else{
                yo.mostrarNotificacion('¡Advertencia!', 'BellIcon', "No pueden agregar nuevos registros porque se encuentra fuera del límite programado.", 'warning', 5000)
              }
            }
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function (){
            yo.loadingSAM = false
            yo.loadingSSM = false
          })

    },

    filtros(){
      this.items = this.spd
      this.items = this.items.filter(
          invoice =>
              invoice.empresa === (this.empresaFiltro || invoice.empresa) &&
              invoice.semana === (this.semanaFiltro || invoice.semana) &&
              invoice.cultivo === (this.cultivoFiltro || invoice.cultivo)
      )
      this.totalRows = this.items.length
    },

    modal_registro(valor){
      console.log("SSSSSSSSSSSSSSSS")
      const yo = this

      console.log(valor)

      if(valor==true){
        yo.modal_registro_entrega=true
      }else{
        yo.modal_registro_devolucion=true
      }

    },

    descargarRegistros(valor){
      const yo = this

      const semmm = valor ? yo.semana : yo.semana_sig
      const datos = yo.items_completo.filter(invoice => invoice.semana === semmm)
      
      console.log(datos)
      yo.loadingSAD = valor
      yo.loadingSSD = !valor

      const data = JSON.stringify(
          {
            "datas":datos
          }
      )

      const config = {
        method: 'post',
        url: '/riego/exportar/filter/',
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'arraybuffer',
        data : data
      };

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              const fileURL = window.URL.createObjectURL(new Blob([response.data]));
              const fileLink = document.createElement('a');
              fileLink.href = fileURL;
              fileLink.setAttribute('download', "Exportar detalle fertilizacion - semana "+ semmm +".xlsx");
              document.body.appendChild(fileLink);
              fileLink.click();

              yo.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Archivo creado',
                      icon: 'CheckIcon',
                      text: 'El archivo se creó satisfactoriamente.',
                      variant: 'success',
                    },
                  },
                  {
                    position: 'top-center',
                  })
            }
          })
          .catch(function (error) {
            console.log(error);
            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error en la creación del archivo',
                icon: 'XIcon',
                text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                variant: 'danger',
              },
            })
          })
          .finally(function () {
            yo.loadingSAD = false
            yo.loadingSSD = false
          });
    }

  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: '';
}


.tablaferti{
  min-height: 52vh!important;
}

.tablaferti::-webkit-scrollbar {
  width: 1.35vh;
  height: 1.35vh;
}
.tablaferti::-webkit-scrollbar-track {
  background-color: rgba(171, 171, 171, 0.35);
  border-radius: 6px;
  position: absolute;
}
.tablaferti::-webkit-scrollbar-thumb {
  background-image: linear-gradient(47deg, #82868b, #9ca0a4);
  border-radius: 6px;
  position: absolute;
}

.contenedor_estacion{
  position:absolute;
  right:0;
  top: 110px;
  z-index:15;
  font-size:18px;
  font-weight:bold
}

//Para ocultarle el boton de cerrar al modal cuando se aperturael modulo
#modal-seleccionar-estacion .close,
.vs__clear{
  display:none
}

.align-right-modal .modal-dialog {
  position: absolute;
  top:15%;
  right: 5%;
}

.align-left-modal .modal-dialog {
  position: absolute;
  top:15%;
  left: 10%;
}

.custom-modal-style .modal-content {
  background-color: transparent;
  box-shadow: none;
}

.modal-backdrop{
  z-index:0;
  width: 0;
}

</style>
